import React, { useState } from 'react';

export const useOtp = ({
  value,
  onChange,
}: {
  value: string[];
  onChange: (value: string[]) => void;
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const setNewOtp = (char: string, index: number) => {
    const newOtp = [...value];
    newOtp[index] = char;
    onChange(newOtp);
  };

  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    let newValue = e.target.value;

    if (newValue.length === 0) {
      setNewOtp('', index);
      return;
    }
    if (value[index] !== '') {
      // remove existing input
      if (
        e.target.selectionStart &&
        newValue.length - e.target.selectionStart > 0
      ) {
        // If the cursor is placed before the existing value, remove the last char
        newValue = newValue.substring(0, newValue.length - 1);
      } else {
        // Remove the first char
        newValue = newValue.substring(1);
      }
    }
    if (newValue.length === 1) {
      setNewOtp(newValue, index);
      setActiveIndex(Math.min(index + 1, value.length - 1));
      return;
    }
    // This is a paste
    const newList = new Array(value.length).fill('');
    const pasteLength = newValue.length;
    for (let i = 0; i < newList.length; i++) {
      if (i < index || i >= index + pasteLength) {
        newList[i] = value[i];
      } else {
        newList[i] = newValue[i - index];
      }
    }
    onChange(newList);
    setActiveIndex(Math.min(newList.length - 1, index + pasteLength));
  };

  const handleOnKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === 'Backspace') {
      if (value[index] === '') {
        setActiveIndex(Math.max(0, index - 1));
      }
    }
  };

  return {
    activeIndex,
    handleOnChange,
    handleOnKeyDown,
  };
};
